import { memo, useState } from "react";

function ResourcesTab({
  c,
  lbl,
  inp,
  resources = [],
  newResourceName,
  setNewResourceName,
  newResourceUrl,
  setNewResourceUrl,
  onCreateResource,
  editingResource,
  setEditingResource,
  onUpdateResource,
  onDeleteResource,
  onMoveResource,
  onReorderResource,
}) {
  const [draggedResourceId, setDraggedResourceId] = useState(null);
  const [dragOverResourceId, setDragOverResourceId] = useState(null);

  return (
    <div style={{ padding: "18px 22px" }}>
      <div style={{ padding: 14, background: c.bgSecondary, borderRadius: "12px", border: `1px solid ${c.border}`, marginBottom: 20 }}>
        <span style={lbl}>Neuen Library-Eintrag erstellen</span>
        <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 10 }}>
          <input type="text" value={newResourceName} onChange={(e) => setNewResourceName(e.target.value)} placeholder="Name..." style={{ ...inp }} />
          <input type="text" value={newResourceUrl} onChange={(e) => setNewResourceUrl(e.target.value)} placeholder="https://..." style={{ ...inp }} />
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button onClick={() => { setNewResourceName(""); setNewResourceUrl(""); }} style={{ background: c.bg === "#0f1117" ? "#2d1515" : "#fff0f0", color: c.bg === "#0f1117" ? "#fc8181" : "#cc3333", border: `1px solid ${c.bg === "#0f1117" ? "#4a2020" : "#ffcccc"}`, borderRadius: "8px", cursor: "pointer", padding: "6px 12px", fontSize: 12 }}>
              Abbrechen
            </button>
            <button onClick={onCreateResource} style={{ background: c.bg === "#0f1117" ? "#0d2d1a" : "#f0fff4", color: c.bg === "#0f1117" ? "#48bb78" : "#276749", border: `1px solid ${c.bg === "#0f1117" ? "#48bb78" : "#9ae6b4"}`, borderRadius: "8px", cursor: "pointer", padding: "6px 12px", fontSize: 12, display: "inline-flex", alignItems: "center", gap: 5 }}>
              💾 Speichern
            </button>
          </div>
        </div>
      </div>

      <span style={lbl}>Library</span>
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 12 }}>
        {resources.length === 0 && (
          <div style={{ fontSize: 13, color: c.textSecondary }}>Noch keine Ressourcen vorhanden.</div>
        )}
        {resources.map((link, index) => (
          <div
            key={link.id || link.name}
            draggable={!!link.id}
            onDragStart={() => {
              if (!link.id) return;
              setDraggedResourceId(link.id);
            }}
            onDragOver={(e) => {
              if (!draggedResourceId || !link.id || draggedResourceId === link.id) return;
              e.preventDefault();
              if (dragOverResourceId !== link.id) setDragOverResourceId(link.id);
            }}
            onDragLeave={() => {
              if (dragOverResourceId === link.id) setDragOverResourceId(null);
            }}
            onDrop={(e) => {
              e.preventDefault();
              if (!draggedResourceId || !link.id || draggedResourceId === link.id) return;
              const dragged = resources.find((item) => item.id === draggedResourceId);
              if (dragged) onReorderResource(dragged, link);
              setDraggedResourceId(null);
              setDragOverResourceId(null);
            }}
            onDragEnd={() => {
              setDraggedResourceId(null);
              setDragOverResourceId(null);
            }}
            style={{
              background: c.bgSecondary,
              border: `1.5px solid ${dragOverResourceId === link.id ? c.accent : c.borderSecondary}`,
              borderRadius: "8px",
              padding: "10px 14px",
              cursor: link.id ? "grab" : "default",
              boxShadow: dragOverResourceId === link.id ? `0 0 0 2px ${c.accent}33` : "none",
              transition: "border-color 120ms ease, box-shadow 120ms ease",
            }}
          >
            {editingResource && editingResource.id === link.id ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <input type="text" value={editingResource.name} onChange={(e) => setEditingResource((prev) => ({ ...prev, name: e.target.value }))} style={{ ...inp }} />
                <input type="text" value={editingResource.url} onChange={(e) => setEditingResource((prev) => ({ ...prev, url: e.target.value }))} style={{ ...inp }} />
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                  <button onClick={() => setEditingResource(null)} style={{ background: c.bg === "#0f1117" ? "#2d1515" : "#fff0f0", color: c.bg === "#0f1117" ? "#fc8181" : "#cc3333", border: `1px solid ${c.bg === "#0f1117" ? "#4a2020" : "#ffcccc"}`, borderRadius: "8px", cursor: "pointer", padding: "6px 10px", fontSize: 12 }}>
                    Abbrechen
                  </button>
                  <button onClick={onUpdateResource} style={{ background: c.bg === "#0f1117" ? "#0d2d1a" : "#f0fff4", color: c.bg === "#0f1117" ? "#48bb78" : "#276749", border: `1px solid ${c.bg === "#0f1117" ? "#48bb78" : "#9ae6b4"}`, borderRadius: "8px", cursor: "pointer", padding: "6px 10px", fontSize: 12, display: "inline-flex", alignItems: "center", gap: 5 }}>
                    💾 Speichern
                  </button>
                </div>
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                <a href={link.url} target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: c.text, textDecoration: "none", flex: 1, minWidth: 0 }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                    <polyline points="15 3 21 3 21 9" />
                    <line x1="10" y1="14" x2="21" y2="3" />
                  </svg>
                  {!!link.id && <span style={{ fontSize: 12, color: c.textTertiary }}>⋮⋮</span>}
                  <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{link.name}</span>
                </a>
                <div style={{ display: "flex", gap: 6 }}>
                  {!!link.id && (
                    <>
                      <button onClick={() => onMoveResource(link, "up")} disabled={index === 0} style={{ background: "none", border: "none", cursor: index === 0 ? "not-allowed" : "pointer", fontSize: 12, color: index === 0 ? c.textTertiary : c.textSecondary, padding: "0 4px", opacity: index === 0 ? 0.3 : 1 }}>↑</button>
                      <button onClick={() => onMoveResource(link, "down")} disabled={index === resources.length - 1} style={{ background: "none", border: "none", cursor: index === resources.length - 1 ? "not-allowed" : "pointer", fontSize: 12, color: index === resources.length - 1 ? c.textTertiary : c.textSecondary, padding: "0 4px", opacity: index === resources.length - 1 ? 0.3 : 1 }}>↓</button>
                      <button onClick={() => setEditingResource({ id: link.id, name: link.name, url: link.url })} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 12, color: "#d97706", padding: "0 4px" }}>✎</button>
                    </>
                  )}
                  <button onClick={() => onDeleteResource(link)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13, color: c.bg === "#0f1117" ? "#fc8181" : "#cc3333", padding: "0 4px" }}>🗑️</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default memo(ResourcesTab);
